import PlayButton from './PlayButton';
import Slider from './Slider';
import Speed from './Speed';

export default {
    PlayButton,
    Slider,
    Speed,
};
